<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mal-text mt-1 custom-title">Centre Edit Requests</h3>
        </div>

        <!-- Status filter -->
        <div class="section mt-1" style="display:flex;gap:6px;">
            <button v-for="s in statusTabs" :key="s.value" @click="setStatus(s.value)" class="qbtn"
                :style="filter_status === s.value ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;'">
                {{ s.label }}
            </button>
        </div>

        <div class="section text-center mt-2" v-if="loading">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="listed-detail mt-3" v-else-if="!requests.length">
            <h3 class="text-center mt-2 text-primary">No requests found</h3>
        </div>

        <div class="section pb-2" v-else>
            <div class="card p-2 mt-2" v-for="r in requests" :key="r.id" style="border-radius:12px;">
                <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
                    <h3 class="mb-0" style="font-size:15px;font-weight:800;color:#1e293b;flex:1;min-width:0;">{{ r.center_name }}</h3>
                    <span :class="statusClass(r.status)" style="font-size:11px;font-weight:700;">{{ statusLabel(r.status) }}</span>
                </div>
                <div style="font-size:11px;color:#64748b;margin-top:2px;">
                    <span v-if="r.center_reg_no">{{ r.center_reg_no }} · </span>{{ r.district_name }} · {{ r.unit_name }}
                </div>
                <div style="font-size:11px;color:#94a3b8;margin-top:2px;">
                    Requested by {{ r.requested_by_name }} · {{ r.created_at }}
                </div>

                <!-- Changed fields (current → proposed) -->
                <div class="mt-2" v-if="changedFields(r).length">
                    <div v-for="f in changedFields(r)" :key="f.key"
                        style="padding:7px 0;border-top:1px solid #f1f3f7;">
                        <div style="font-size:11px;color:#64748b;font-weight:700;">{{ f.label }}</div>
                        <div style="display:flex;align-items:center;gap:8px;font-size:13px;margin-top:2px;">
                            <span style="color:#d9534f;text-decoration:line-through;flex:1;min-width:0;word-break:break-word;">{{ f.old || '—' }}</span>
                            <ion-icon name="arrow-forward-outline" style="color:#94a3b8;flex-shrink:0;"></ion-icon>
                            <span style="color:#12a85a;font-weight:700;flex:1;min-width:0;word-break:break-word;">{{ f.new || '—' }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="mt-2" style="font-size:12px;color:#94a3b8;">No field changes detected.</div>

                <div v-if="r.status === 'denied' && r.review_remarks" class="mt-2" style="font-size:12px;color:#d9534f;">
                    Remark: {{ r.review_remarks }}
                </div>

                <!-- Actions (pending only) -->
                <div v-if="r.status === 'pending'" style="display:flex;gap:8px;margin-top:10px;">
                    <button @click="deny(r)" :disabled="acting" class="btn btn-sm btn-outline-danger" style="flex:1;border-radius:8px;">Deny</button>
                    <button @click="approve(r)" :disabled="acting" class="btn btn-sm btn-success" style="flex:1;border-radius:8px;">
                        <span v-if="acting" class="spinner-border spinner-border-sm me-1"></span>
                        Approve
                    </button>
                </div>
            </div>
        </div>

        <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    </div>
</template>

<script>
import UserService from "../../services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

const FIELD_LABELS = {
    center_name: 'Centre Name',
    center_adress: 'Address',
    center_location: 'Location',
    center_type: 'Centre Type',
    class_type: 'Class Type',
    no_of_rooms: 'No. of Rooms',
    no_of_benches: 'No. of Benches',
    no_of_desks: 'No. of Desks',
    no_of_estimated_registrations: 'Estimated Registrations',
    office_room: 'Office Room',
    library: 'Library',
    toilet: 'Toilet',
    rest_area: 'Rest Area',
    projector: 'Projector',
    board: 'Board',
    fan_ac: 'Fan / AC',
    drinking_water: 'Drinking Water',
    none_of_above: 'None of Above',
    org_cordinator: 'ORG Coordinator (ID)',
    youth_cordinator: 'Youth Coordinator (ID)',
    women_cordinator: "Women's Coordinator (ID)",
};
const BOOL_FIELDS = ['office_room', 'library', 'toilet', 'rest_area', 'projector', 'board', 'fan_ac', 'drinking_water', 'none_of_above'];

export default {
    name: "QHLSCenterEditRequests",
    components: { AlertModel },
    data() {
        return {
            loading: false,
            acting: false,
            alert_type: "",
            alert_message: "",
            filter_status: "pending",
            requests: [],
            statusTabs: [
                { value: "pending", label: "Pending" },
                { value: "approved", label: "Approved" },
                { value: "denied", label: "Denied" },
            ],
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        if (parseInt(String(this.currentUser.user_level), 10) !== 1) {
            this.alert_type = "Warning";
            this.alert_message = "You have no permission!";
            this.$refs.alert_model.openModel();
            return;
        }
        this.$root.updateParent("Centre Edit Requests");
        this.load();
    },
    methods: {
        setStatus(s) {
            this.filter_status = s;
            this.load();
        },
        load() {
            this.loading = true;
            UserService.authPostRequest("get-cre-edit-requests", { status: this.filter_status }).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status === "success") {
                        this.requests = response.data.data.list || [];
                    }
                },
                () => { this.loading = false; }
            );
        },
        normalizeBool(v) {
            return (v === true || v === 'true' || v === 'Y' || v === 1 || v === '1');
        },
        displayVal(key, v) {
            if (BOOL_FIELDS.includes(key)) return this.normalizeBool(v) ? 'Yes' : 'No';
            return (v === null || v === undefined || v === '') ? '' : String(v);
        },
        changedFields(r) {
            const out = [];
            const proposed = r.proposed || {};
            const current = r.current || {};
            Object.keys(FIELD_LABELS).forEach((key) => {
                if (!(key in proposed)) return;
                let oldV = current[key];
                let newV = proposed[key];
                let same;
                if (BOOL_FIELDS.includes(key)) {
                    same = this.normalizeBool(oldV) === this.normalizeBool(newV);
                } else {
                    same = String(oldV ?? '') === String(newV ?? '');
                }
                if (!same) {
                    out.push({ key, label: FIELD_LABELS[key], old: this.displayVal(key, oldV), new: this.displayVal(key, newV) });
                }
            });
            return out;
        },
        statusLabel(s) {
            return s === 'pending' ? 'Pending' : s === 'approved' ? 'Approved' : 'Denied';
        },
        statusClass(s) {
            return s === 'pending' ? 'text-warning' : s === 'approved' ? 'text-success' : 'text-danger';
        },
        approve(r) {
            this.act(r, 'approve', null);
        },
        deny(r) {
            const remarks = window.prompt('Reason for denial (optional):', '');
            if (remarks === null) return; // cancelled
            this.act(r, 'deny', remarks);
        },
        act(r, action, remarks) {
            this.acting = true;
            UserService.authPostRequest("action-cre-edit-request", { id: r.id, action, remarks }).then(
                (response) => {
                    this.acting = false;
                    this.alert_type = response.data.status === 'success' ? 'Success' : 'Warning';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    if (response.data.status === 'success') this.load();
                },
                () => { this.acting = false; }
            );
        },
    },
};
</script>

<style scoped>
.qbtn {
    flex: 1;
    padding: 8px 0;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
}
</style>
